import Gengar from './Gengar';
import image from './preview.png';

export const Image = image;
export default Gengar;
